// extracted by mini-css-extract-plugin
export default {"fr-view":"Menu_fr-view__URdEu","menu":"Menu_menu__ejrx0"};